// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Fjalla_One_0cbda2', '__Fjalla_One_Fallback_0cbda2'","fontWeight":400,"fontStyle":"normal"},"className":"__className_0cbda2","variable":"__variable_0cbda2"};